import { getRegisterFunction } from '../../utils/register.js';
import { OneUxIconElement } from './OneUxIconElement.js';
export const register = getRegisterFunction(OneUxIconElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-icon': OneUxIconElement;
    "icon-c61400efa77de36d52c1fe3f7dc49f4d": OneUxIconElement;
  }
}